import { ref, computed } from "vue";
import { defineStore, storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import { useCurrentUserStore } from "../../currentUser";
import { useSurveyStore } from "../survey";

export const useGeneralSetupStore = defineStore("generalSetup", () => {
  const route = useRoute();
  // imported stores
  const currentUserStore = useCurrentUserStore();
  const { isAdmin } = storeToRefs(currentUserStore);
  const surveyStore = useSurveyStore();
  const { survey } = storeToRefs(surveyStore);
  const isCreatingSurvey = computed(() => route.name === "SurveyNew");

  const fields = ref([
    { name: "survey_title", label: "Survey title", admin: false },
    { name: "survey_design_mode", label: "Desing Mode", admin: false },
    { name: "survey_languages", label: "Languages", admin: false },
    { name: "survey_status", label: "Status", admin: false },
    { name: "survey_access_control", label: "Access control", admin: true },
    { name: "survey_allow_multiple", label: "Allow multiple", admin: true },
    { name: "survey_crm_id", label: "CRM Id", admin: true },
    { name: "survey_account", label: "Account", admin: false },
    { name: "survey_owner", label: "Owner", admin: true },
    { name: "survey_progress_indicator", label: "Progress bar", admin: false },
  ]);

  const currentFields = computed(() => {
    let filteredFields = fields.value.filter((s) => s.admin === false || isAdmin.value);
    if (!isCreatingSurvey.value) filteredFields = filteredFields.filter((s) => s.name !== "survey_design_mode");
    if (survey.value?.ai_chat) filteredFields = filteredFields.filter((s) => s.name !== "survey_progress_indicator");
    return filteredFields;
  });

  return {
    isAdmin,
    currentFields,
  };
});
